<div>
  @if (type == 'array') {
    <div class="array">
    @for(item of obj; track $index; let i = $index; let last = $last) {
      @if (typeof(item.value) == 'object' ) {
        <div class="bottom-separator">
          <export-collapsible>
            <div title><div [ngClass]="isObjectEmpty(item.value) ? 'empty' : ''">{{ $index }}</div></div>
            <div body><export-nested-object [obj]="item" /></div>
          </export-collapsible>
        </div>
      } @else {
        <div class="element" [ngClass]="last ? '' : 'bottom-separator'">
          * {{ item }}
        </div>
      }
    }
    </div>
  } 
  @else if (type == 'object') {
    @for(item of obj | keyvalue; track $index) {
      @if (typeof(item.value) == 'object' ) {
        <div class="bottom-separator">
          <export-collapsible>
            <div title><div [ngClass]="isObjectEmpty(item.value) ? 'empty' : ''">{{ item.key }}</div></div>
            <div body><export-nested-object [obj]="item.value" /></div>
          </export-collapsible>
        </div>
      }
      @else {
        <div class="primitive bottom-separator">
          <div class="key" [ngClass]="isObjectEmpty(item.value) ? 'empty' : ''">{{ item.key }}</div>
          <div class="value">{{ item.value }}</div>
        </div>  
      }
    }
  }
</div>